import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-vertical',
  templateUrl: './layout-vertical.component.html',
  styleUrls: ['./layout-vertical.component.scss']
})
export class LayoutVerticalComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
